import * as React from 'react';
import { LxValueProps } from "./inputs";

export interface BaseTabProps extends LxValueProps<string> {
    classes: { tabs: string; };
    label? : string | JSX.Element;
    children : React.ReactNode;
}

const SelectedTab = React.createContext( null );

/**
 * Base for tabs. Is not styles and is not intended to be used by itself
 */
export const BaseTabs = ({ classes, label, children, $value, value, ...props } : BaseTabProps ) => {

    return (
        <label className={ classes.tabs }>
            { label ? <span className="label">{label}</span> : null }
            <SelectedTab.Provider value={ $value }>
                { children }
            </SelectedTab.Provider>
        </label>
    );
};

export const Tab = ({ value, children, title } : {
    value: string
    children: React.ReactNode
    title? : React.ReactNode
} ) => {
    const $value = React.useContext(SelectedTab).equals(value);

    const classes = 'tab';

    return (
        <span
            className={ $value.value ? 'selected ' + classes : classes }
            onClick={ e => {
                e.stopPropagation();
                $value.set( true );
            }}
        >
            { title ?
                <div className="title">
                    { title }
                </div>
            : null }

            <div className="body">
                { children }
            </div>
        </span>
    );
};
